import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import symptomHandler from '../../../utilities/symptomHandler';
import SymptomModal from './Symptom Modal/SymptomModal';

function SymptomItem(props)
{
const [opened,setOpened] = useState(false)
const [modalOpen, setModalOpen]= useState(false)

let symptomObject=symptomHandler.createSymptomObject(props.symptom)

const clickFunction=(e)=>
    {
    setModalOpen(true);
    setOpened(true)
    props.setModalHasRun(true)
    }

useEffect(()=>{
    if (modalOpen===false && opened === true)
        {
        props.setIndexReturning(props.index)
        }
        },[modalOpen]) 
        
return(<>
    <Box>
    <Typography variant='subtext' >
        {symptomObject["symptomText"]}
    </Typography>
    <Button  size="small" variant='contained' sx={{margin:1,  backgroundColor:(opened? "green" :"red")}} onClick={clickFunction}>Add Info.</Button>
    </Box>
    <SymptomModal  symptomObject = {symptomObject} modalOpen={modalOpen} setModalOpen={setModalOpen}/>
    </>
)

}

export default SymptomItem
